import ApplicationList from './ApplicationList.vue'

export default ApplicationList



// WEBPACK FOOTER //
// ./client/masteradmin/pages/ApplicationList/index.js